var map = {
	"./half_pitch_black.png": "NtN7",
	"./half_pitch_blue.png": "vQdk",
	"./half_pitch_green.png": "EdVJ",
	"./half_pitch_grey.png": "0LPn",
	"./half_pitch_white.png": "8+0S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4KoN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/half_pitch_.*\.png$
// module id = 4KoN
// module chunks = 94